import { FlexRowBetween, PageHeader } from 'components'
import { AppButton, AppPrimaryButton } from 'elements'
import { Input } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { DesktopMode, MobileMode } from 'layout'
import { AuthService, getTemplatePermissions } from 'utility'

// 2026-10-18 layout: title + count on the left; search, the two secondary create options (outlined)
// and Create (primary) on the right, wrapping instead of running off the screen.
const HeaderBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px 16px;
    .template-header-count {
        margin: -6px 0 0;
        color: #5b6475;
        font-size: 13px;
    }
    .template-header-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }
    .template-header-actions .ui.button {
        margin: 0;
    }
`

const OutlineButton = styled(AppButton)`
    &&& {
        background: #ffffff;
        color: #14181f;
        border: 1px solid #cfd5e3;
        box-shadow: none;
    }
    &&&:hover {
        background: #f4f6fa;
    }
`

export const TemplateListHeader = ({
    search,
    setSearch,
    handleSearchClick,
    handleKeyPress,
    onCreateClick,
    headerText,
    totalCount,
}) => {
    const { canCreateTemplate } = getTemplatePermissions(AuthService.getUser())
    const countText =
        typeof totalCount === 'number' && totalCount >= 0
            ? `${totalCount} template${totalCount === 1 ? '' : 's'}`
            : ''

    return (
        <>
            <DesktopMode>
                <HeaderBar>
                    <div>
                        <PageHeader header={headerText} />
                        {countText && (
                            <p className="template-header-count">{countText}</p>
                        )}
                    </div>
                    <div className="template-header-actions">
                        <span>
                            <Input
                                placeholder="Search"
                                value={search}
                                onChange={(_, text) => {
                                    setSearch(text.value)
                                    if (text.value.trim() === '') {
                                        handleSearchClick()
                                    }
                                }}
                                onKeyPress={handleKeyPress}
                                icon={{
                                    name: 'search',
                                    circular: true,
                                    link: true,
                                    onClick: handleSearchClick,
                                    className:
                                        'bg-blue-800 text-white p-2 rounded-full hover:bg-blue-600',
                                }}
                            />
                        </span>
                        {canCreateTemplate && (
                            <>
                                <Link to="/app/templates/new-template-library">
                                    <OutlineButton type="button">
                                        New Template From Library
                                    </OutlineButton>
                                </Link>
                                <Link to="/app/templates/create-ai-template">
                                    <OutlineButton type="button">
                                        Create Template From AI
                                    </OutlineButton>
                                </Link>
                                <AppPrimaryButton onClick={onCreateClick}>
                                    Create
                                </AppPrimaryButton>
                            </>
                        )}
                    </div>
                </HeaderBar>
            </DesktopMode>
            <MobileMode>
                <FlexRowBetween className="mb-2">
                    <PageHeader header={headerText} />
                    {canCreateTemplate && (
                        <AppPrimaryButton onClick={onCreateClick}>
                            Create
                        </AppPrimaryButton>
                    )}
                </FlexRowBetween>
                {canCreateTemplate && (
                    <div className="">
                        <Link
                            className="col-12"
                            to="/app/templates/new-template-library"
                        >
                            <OutlineButton fluid type="button">
                                New Template From Library
                            </OutlineButton>
                        </Link>
                        <Link
                            className="col-12 mt-3"
                            to="/app/templates/create-ai-template"
                        >
                            <OutlineButton fluid type="button" className="mt-2">
                                Create Template From AI
                            </OutlineButton>
                        </Link>
                    </div>
                )}
                <div className="col-12 mt-3">
                    <Input
                        placeholder="Search"
                        className="col-12"
                        value={search}
                        onChange={(_, text) => setSearch(text.value)}
                        onKeyPress={handleKeyPress}
                        icon={{
                            name: 'search',
                            circular: true,
                            link: true,
                            onClick: handleSearchClick,
                        }}
                    />
                </div>
            </MobileMode>
        </>
    )
}
